<template>
	<el-dialog  :visible.sync="showEnterpriseModify"   width="550px">
	<el-form ref="form" :rules="rules" :model="super_form" label-width="110px" >
	
	  <el-form-item label="社会信用证代码">
	    <el-input :disabled="true" v-model="super_form.socialCreditCode" style="width: 370px;" />
	  </el-form-item>
	  <el-form-item label="企业名称" prop="enterpriseName">
	    <el-input :disabled="isdisabledFn" v-model="super_form.enterpriseName" style="width: 370px;" />
	  </el-form-item>
	  
	  <el-form-item label="联系电话" prop="phone">
	    <el-input :disabled="isdisabledFn" v-model="super_form.phone" style="width: 370px;" />
	  </el-form-item>
	
	  <el-form-item label="对接人" prop="contactName">
	    <el-input :disabled="isdisabledFn" v-model="super_form.contactName" style="width: 370px;" />
	  </el-form-item>
	  <el-form-item label="邮箱" prop="email">
	    <el-input :disabled="isdisabledFn" v-model="super_form.email" style="width: 370px;" />
	  </el-form-item>
	  <el-form-item label="发票抬头" prop="invoiceTitle">
	    <el-input :disabled="isdisabledFn" v-model="super_form.invoiceTitle" style="width: 370px;" />
	  </el-form-item>
	  <el-form-item label="开户行" prop="bankName">
	    <el-input :disabled="isdisabledFn" v-model="super_form.bankName" style="width: 370px;" />
	  </el-form-item>
	  <el-form-item label="卡号" prop="bankCode">
	    <el-input :disabled="isdisabledFn" v-model="super_form.bankCode" style="width: 370px;" />
	  </el-form-item>
	  <el-form-item label="营业执照" style="width: 370px;">
	    <div v-if="!super_form.businessLicense">
	
	      <el-upload
	        :headers="headers"
	        :action="imagesUploadApi"
	        :on-success="handleSuccess"
	        :limit="1"
	        class="upload-demo"
	        multiple>
	        <el-button size="small" type="primary">点击上传</el-button>
	        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
	      </el-upload>
	
	    </div>
	    <div v-else>
	
	      <img :src="this.super_form.businessLicense" style="width: 50px; height: 50px" @click="handlePictureCardPreviewSrc(super_form.businessLicense)">
	      <el-dialog :append-to-body="true" :visible.sync="dialogVisiblesrc">
	        <img :src="dialogImageUrlsrc" width="100%" alt="">
	      </el-dialog>
	    </div>
	  </el-form-item>
		
		
	</el-form>
	<span slot="footer" class="dialog-footer">
	    <el-button @click="showEnterpriseModify = false">取 消</el-button>
	    <el-button :loading="loading" type="primary" @click="doSubmit">确 定</el-button>
	  </span>
	</el-dialog>
</template>

<script>
	import checkPermission from '@/utils/permission'

	import {
	  editSelf
	} from '@/api/company'
	import {
	  mapGetters
	} from 'vuex'
	import {
	  getToken
	} from '@/utils/auth'
	export default{
		props:{
			super_form:Object
		},
		data() {
		  return {
			  isdisabledFn:false,
			  loading: false,
			  imagesUploadApi:process.env.VUE_APP_API_URL+"/api/pictures",
			showEnterpriseModify:false,
		    dialogVisiblesrc: false,
		    dialogImageUrlsrc: '',
		    delLoading: false,
		    sup_this: this,
		    headers: {
		      'Authorization': 'Bearer ' + getToken()
		    },
		    rules: {
		      enterpriseName: [{
		        required: true,
		        message: '企业名称不能为空',
		        trigger: 'blur'
		      }],
		      phone: [{
		        required: true,
		        message: '手机号码不能为空',
		        trigger: 'blur'
		      }],
		      contactName: [{
		        required: true,
		        message: '合同名称不能为空',
		        trigger: 'blur'
		      }],
		      invoiceTitle: [{
		        required: true,
		        message: '发票抬头不能为空',
		        trigger: 'blur'
		      }],
		      email: [{
		        required: true,
		        message: '邮箱不能为空',
		        trigger: 'blur'
		      }],
		      bankName: [{
		        required: true,
		        message: '银行名称不能为空',
		        trigger: 'blur'
		      }],
		      bankCode: [{
		        required: true,
		        message: '银行账号不能为空',
		        trigger: 'blur'
		      }]
		    }
		  }
		},
		methods: {
		  checkPermission,
		
		
		  handleSuccess(response) {
		    console.log(response)
		    this.super_form.businessLicense = response.data[0]
		    console.log(this.super_form)
		  },
		  handleBeforeRemove(file, fileList) {
		
		  },
		  handlePictureCardPreview(file) {
		    this.dialogImageUrl = file.url
		    this.dialogVisible = true
		  },
		  handlePictureCardPreviewSrc(src) {
		    this.dialogImageUrlsrc = src
		    this.dialogVisiblesrc = true
		  },
		  // 监听上传失败
		  handleError(e, file, fileList) {
		    const msg = JSON.parse(e.message)
		    this.$notify({
		      title: msg.message,
		      type: 'error',
		      duration: 2500
		    })
		  },
		  doSubmit() {
		    this.$refs['form'].validate((valid) => {
		      if (valid) {
		        if (this.super_form.businessLicense == '' || this.super_form.businessLicense == null) {
		          this.$alert('必须要上传营业执照才能进行审核', '提示', {
		            confirmButtonText: '确定'
		          })
		          return false
		        }
		        this.super_form.enterpriseAuditStatus = 1
		        editSelf(this.super_form).then(res => {
		          this.$notify({
		            title: '修改成功',
		            type: 'success',
		            duration: 2500
		          })
		          this.loading = false
				  this.showEnterpriseModify = false
		        }).catch(err => {
		          this.loading = false
		          console.log(err.response.data.message)
		        })
		      } else {
		        return false
		      }
		    })
		  }
		}
		
	}
	
</script>

<style>
</style>
